import Swiper from 'swiper/bundle'; // css file is added locally

const swiperCards = new Swiper('.cards__slider', {
    speed: 300,
    slidesPerView: 1.1,
    spaceBetween: '6%',
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: '4%'
        },
        1201: {
            slidesPerView: 3,
            spaceBetween: '4%'
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
});

const swiperContentImageBlocks = new Swiper('.content-image-blocks .block__slider', {
    loop: true,
    speed: 300,
    slidesPerView: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    }
});

const swiperTestimonials = new Swiper('.testimonials__slider',{
    loop: true,
    speed: 300,
    slidesPerView: 1,
    spaceBetween: '25%',
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
});

const swiperBackgroundSlider = new Swiper('.section__background-slider .swiper', {
    loop: true,
    speed: 1000,
    slidesPerView: 1,
    autoplay: {
        delay: 4000,
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    on: {
        activeIndexChange: function(swiper) {
            $(swiper.slides[swiper.activeIndex]).find('img').addClass('section__background-image--zoom');
        }
    }
});

const topBarWIP = new Swiper('.top-bar__wip-carousel',{
    loop: true,
    speed: 500,
    slidesPerView: 1,
    autoplay: {
        delay: 2000,
    },
    observer: true,
    observeParents: true,
    on: {
        afterInit: function (swiper) {
            updateTopBarWIPSliderWidth(swiper);
        },
        resize: function (swiper) {
            swiper.el.style.width = 'auto';
            updateTopBarWIPSliderWidth(swiper);
        }
    }
});

function updateTopBarWIPSliderWidth(swiper) {
    swiper.el.style.width = '';

    let maxWidth = 0;

    swiper.slides.forEach(slide => {
        slide.style.display = 'inline-block';
        slide.style.width = 'max-content';

        const slideFullWidth = slide.getBoundingClientRect().width;

        if (slideFullWidth > maxWidth) {
            maxWidth = slideFullWidth;
        }

        slide.style.display = '';
        slide.style.width = '';
    });

    if (maxWidth > 0) {
        const finalWidth = Math.ceil(maxWidth) + 1;

        swiper.el.style.width = finalWidth + 'px';
        swiper.update();
    }
}
